import { v4 as uuidv4 } from "uuid";

import UserThumbnail from "assets/images/user.png";
import BotThumbnail from "assets/images/bot.png";
import { setSession } from "redux/services";

const defaultMsg = "Something went wrong, please try after some time.";

export const getMsg = (res) => {
  if (res?.data?.message) {
    return res.data.message;
  } else {
    return defaultMsg;
  }
};

export const parseDate = (dateString) => {
  if (dateString) {
    const date = new Date(dateString);
    return date.toLocaleString();
  } else {
    return new Date().toLocaleString();
  }
};

export const getChats = (data) => {
  return data.reduce((res, ele, idx) => {
    const createdAt = parseDate(ele?.createdAt);
    res.push({
      ...ele,
      key: uuidv4(),
      id: ele?.id,
      botId: ele?.botId,
      text: ele?.user,
      isFromUser: true,
      thumbnail: UserThumbnail,
      isNew: false,
      createdAt,
    });
    res.push({
      ...ele,
      key: uuidv4(),
      id: ele?.id,
      botId: ele?.botId,
      text: ele?.assistant,
      isFromUser: false,
      thumbnail: BotThumbnail,
      isNew: false,
      createdAt,
    });
    return res;
  }, []);
};

export const addUuid = () => {
  let newSessionId = uuidv4();
  setSession(newSessionId);
  return newSessionId;
};

export const getChatForUser = (oldData, newData) => {
  const newUid = uuidv4();
  const newAid = uuidv4();
  const createdAt = parseDate();
  return [
    ...oldData,
    {
      key: newUid,
      id: newUid,
      botId: newData?.botId,
      text: newData?.content,
      isFromUser: true,
      thumbnail: UserThumbnail,
      createdAt,
    },
    {
      isNew: true,
      key: newAid,
      id: newAid,
      botId: newData?.botId,
      text: "",
      isFromUser: false,
      thumbnail: BotThumbnail,
      createdAt,
    },
  ];
};

export const getChatForAssistant = (oldData, newData) => {
  return oldData.reduce((res, ele) => {
    res.push({
      ...ele,
      text: ele?.text === "" ? newData?.content : ele?.text,
      sources: ele?.text === "" ? newData?.sources : ele?.sources,
    });
    return res;
  }, []);
};


export const  isURL = (str) => {
  const urlPattern = /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/i;
  return urlPattern.test(str);
}

export const getTextColor = (bgColor) => {
  if(bgColor){
  const brightness = calculateBrightness(bgColor);
  const hexColor = bgColor?.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, (m, r, g, b) => r + r + g + g + b + b);
  return brightness > 128 ? '#000000' : '#' + hexColor.toUpperCase();

  }
};

const calculateBrightness = (color) => {
  if (color !== null) {
    const hexColor = color?.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, (m, r, g, b) => r + r + g + g + b + b);
    const r = parseInt(hexColor.substr(0, 2), 16);
    const g = parseInt(hexColor.substr(2, 2), 16);
    const b = parseInt(hexColor.substr(4, 2), 16);
    return (r * 299 + g * 587 + b * 114) / 1000;
  }
};
